<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("soundformats") }}</div>
        <div class="section-subTitle my-2">
          Manage All your Sound Formats here.
        </div>
      </div>
      <div>
        <b-button
          v-if="$can('create', 'Sound Format')"
          variant="default"
          :to="{ name: 'Add Sound Format' }"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:500="getsoundFormatList"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <!-- <b-dropdown
            :text="filter_is_active_label"
            variant="dropdown-curve"
            class="ml-auto mr-3 movie-dropdown"
          >
            <b-dropdown-item @click="onChangeFilterIsActive('Active')"
            >Active</b-dropdown-item
            >
            <b-dropdown-item @click="onChangeFilterIsActive('Inactive')"
            >Inactive</b-dropdown-item
            >
            <b-dropdown-item @click="onChangeFilterIsActive('All')">All</b-dropdown-item>
          </b-dropdown> -->
          <FilterByStatusDropdown
            :onSelect="
              (filterIsActive) => {
                getsoundFormatList(filterIsActive);
              }
            "
          />
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->

    <table class="list-view-table">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th style="width: 200px">
            <img
              v-if="this.columnName != 'sound_format_name'"
              @click="onSortValue('sound_format_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('sound_format_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('sound_format_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("category", 1) }}
          </th>
          <th class="text-left pl-2">
            <img
              v-if="this.columnName != 'sf_order'"
              @click="onSortValue('sf_order', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('sf_order', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('sf_order', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("order") }}
          </th>
        </tr>
      </thead>
      <tbody v-if="soundFormatList.length > 0">
        <tr
          v-for="(format, formatLoopKey) in soundFormatList"
          :key="formatLoopKey"
        >
          <!-- <td>
            <div class="d-flex align-items-center justify-content-end">
              <StatusDot
                :status="
                  format.sound_format_is_active === 'Y'
                    ? 'active'
                    : format.sound_format_is_active === 'N' && 'inactive'
                "
              />
              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  v-if="$can('update', 'Sound Format')"
                  :to="{
                    name: 'Edit Sound Format',
                    params: { sound_format_id: format.sound_format_id },
                  }"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  :to="{
                    name: 'View Sound Format',
                    params: { sound_format_id: format.sound_format_id },
                  }"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td> -->
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="
                  format.sound_format_is_active === 'Y' ? 'active' : 'inactive'
                "
              />
              <router-link
                v-if="$can('update', 'Sound Format')"
                :to="{
                  name: 'Edit Sound Format',
                  params: { sound_format_id: format.sound_format_id },
                }"
                class="ml-4 clickable-icon"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <i class="edit-pen icon blue-icon"></i>
              </router-link>
              <router-link
                :to="{
                  name: 'View Sound Format',
                  params: { sound_format_id: format.sound_format_id },
                }"
                class="ml-2 clickable-icon"
                v-b-tooltip="'View'"
                tabindex="0"
              >
                <i class="icon-eye icon blue-icon"></i>
              </router-link>
            </div>
          </td>
          <td>{{ format.sound_format_name }}</td>
          <td>
            <div class="d-flex align-items-center justify-content-start pl-2">
              {{ format.sf_order }}
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-if="soundFormatList.length == 0">
        <tr>
          <td colspan="3">
            <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      soundFormatList: [],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: null,
      searchValue: "",

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
      // filter_is_active_label: "Active",
      // filter_is_active: "Y"
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  mounted() {
    this.getsoundFormatList();
  },
  methods: {
    // onChangeFilterIsActive(option) {
    //   this.filter_is_active_label = option;
    //   switch (option.toLowerCase()) {
    //     case 'active':
    //       this.filter_is_active = 'Y';
    //       break;
    //     case 'inactive':
    //       this.filter_is_active = 'N';
    //       break;
    //     default:
    //       this.filter_is_active = null;
    //       break;
    //   }
    //   this.getsoundFormatList();
    // },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getsoundFormatList();
    },
    getsoundFormatList(filterIsActive = "Y") {
      this.soundFormatList = [];
      MasterService.GetSoundFormatList({
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
        searchValue: this.searchValue,
        filter_is_active: filterIsActive,
      })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.soundFormatList = data.Records;
            console.log("this.soundFormatList :>> ", this.soundFormatList);
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getsoundFormatList();
      } else {
        this.currentPage = event;
        this.getsoundFormatList();
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 4 },
        { name: "40", id: 5 },
        { name: "50", id: 6 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/SoundFormatsComponent/soundFormats.vue